export * from './RegionSettingsPage';
export { RegionSettingsPage as default } from './RegionSettingsPage';
